const money = (n) => `$${(Number(n) || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const pretty = (iso) => {
  const [y, m, d] = String(iso).split('-').map(Number);
  return new Date(y, m - 1, d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const RedatePreviewTable = ({ stubs }) => (
  <div className="overflow-x-auto rounded-lg border border-zinc-800" data-testid="redate-preview-table">
    <table className="w-full text-sm">
      <thead className="bg-zinc-900 text-[11px] uppercase tracking-wider text-zinc-500">
        <tr>
          <th className="text-left px-3 py-2">Stub</th>
          <th className="text-left px-3 py-2">Pay Date</th>
          <th className="text-left px-3 py-2">Pay Period</th>
          <th className="text-left px-3 py-2">Check #</th>
          <th className="text-right px-3 py-2"># in Year</th>
          <th className="text-right px-3 py-2">YTD Gross</th>
        </tr>
      </thead>
      <tbody>
        {stubs.map((s, i) => (
          <tr key={s.payDate} className="border-t border-zinc-800" data-testid={`redate-row-${i}`}>
            <td className="px-3 py-2 text-zinc-400">{i === 0 ? 'Most recent' : `Prior ${i}`}</td>
            <td className="px-3 py-2 text-white font-medium" data-testid={`redate-row-${i}-paydate`}>{pretty(s.payDate)}</td>
            <td className="px-3 py-2 text-zinc-300">{pretty(s.periodStart)} – {pretty(s.periodEnd)}</td>
            <td className="px-3 py-2 text-zinc-400 font-mono">{s.checkNumber || '—'}</td>
            <td className="px-3 py-2 text-right text-zinc-300">{s.stubNumberInYear}</td>
            <td className="px-3 py-2 text-right text-sky-300 font-mono" data-testid={`redate-row-${i}-ytd`}>{money(s.ytd.grossPay)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);
